import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Slide from '@mui/material/Slide';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function AlertDialogSlide({updateServiceWorker}) {

  return (
    <React.Fragment>
      <Dialog
        open={true}
        TransitionComponent={Transition}
        keepMounted
        onClose={updateServiceWorker}
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle>{"¡Atención!"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
          Hay una nueva versión disponible. Haz clic aquí para actualizar.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={updateServiceWorker}>Actualizar</Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}